export enum ProcessStep {
    REGISTERED = 1,
    WAITING_FOR_APPROVER_PARENT_CONSENT = 2,
    // biome-ignore lint/suspicious/noDuplicateEnumValues: both WAITING_FOR_APPROVER_PARENT_CONSENT and WAITING_FOR_APPROVER_KYC_CONSENT have the same value, because for the user is is step 2 in the process
    HAS_PENDING_KYC_CONSENT = 2,
    COMPLETE = 3,
}
